/**
 * El id que un `UiField` pone y su control recoge.
 *
 * `UiField` dibuja `<label :for="id">` y ofrecía ese id por el slot. De los 890
 * campos con etiqueta del repositorio lo pasaba ninguno, así que cada etiqueta
 * del ERP apuntaba a un id inexistente: pulsarla no enfocaba nada, y un lector
 * de pantalla se quedaba sin el nombre del control.
 *
 * Un símbolo y no una cadena para que no choque con lo que provea cualquier
 * otro sitio, y en su propio fichero porque lo comparten el campo y los tres
 * controles que pueden ir dentro.
 */
export const FIELD_ID = Symbol('ui-field-id')
